import React from 'react';
import CheckHasData from "../check-has-data.jsx";
import BaseNode from "./base-node.jsx";
import {Types} from "../enums.js";

const Annotation = ({ data, selected }) => {

    const title = () => {
        return (
            <>
                <p className={"!mb-[2px] text-[#676a6c]"}><b>Anotação</b></p>
            </>
        )
    }

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex"}>
                <p className="mb-0 ml-1 text-[6px] overflow-hidden [display:-webkit-box] [-webkit-line-clamp:6] [-webkit-box-orient:vertical]">
                    <CheckHasData value={data.value} />
                </p>
            </div>
        </div>
    );

    return (
        <BaseNode
            title={title()}
            image={null}
            infoBlock={infoBlock}
            onSearchAll={() => {}}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-gray-300"}
            bgBody={"bg-white"}
            type={Types.ANNOTATION}
        />
    );
};

export default Annotation;